import TextField from "@material-ui/core/TextField";
import React from "react";

export default function NumberField({ min, max, ...props }) {

  const onChange = (e) => {
    let value = parseInt(e.target.value, 10);
    if (min !== undefined) {
      value = Math.max(min, value);
    }
    if (max !== undefined) {
      value = Math.min(max, value);
    }
    props.onChange((value || value === 0) ? value : "");
  };

  return (
    <TextField
      {...props}
      value={props.value}
      label={props.label}
      variant="outlined"
      inputProps={{
        ...props.inputProps,
        max,
        min,
      }}
      onChange={onChange}
    />
  );
}

